import { createSlice } from "@reduxjs/toolkit"
import {
  getRolesLists,
  getAllRolesLists,
  deleteRole,
  getPermissions,
  createRole,
  getSingleRole,
  updateRole,
  getUserRoleAndPermissions,
  getCandiateRoleData,
} from "store/actions/roleAction"

const payloadInitialState = {
  limit: 50,
  page_number: 1,
  order_by: 1,
  filters: {
    keyword: "",
    status: 1,
  },
}

const initialState = {
  loading: false,
  perPage: 50,
  totalPages: null,
  currentPage: null,
  totalCount: null,
  allRoles: [],
  roles: [],
  permissions: [],
  role: null,
  userRole: null,
  candidateRole: null,
  payload: payloadInitialState,
  isShowFilter: false,
}

const rolesSlice = createSlice({
  name: "RolesAndPermissions",
  initialState,
  reducers: {
    setPayload: (state, action) => {
      state.payload = { ...state.payload, ...action.payload }
    },
    resetPayload: state => {
      state.payload = payloadInitialState
    },
    toggleFilterVisibility: state => {
      state.isShowFilter = !state.isShowFilter
    },
  },
  extraReducers: builder => {
    builder
      .addCase(getRolesLists.pending, state => {})
      .addCase(getRolesLists.fulfilled, (state, action) => {
        const { success, data } = action.payload || {}
        if (success) {
          state.allRoles = data
        }
      })
      .addCase(getRolesLists.rejected, (state, action) => {})

    builder
      .addCase(getAllRolesLists.pending, state => {
        state.loading = true
        state.totalPages = null
        state.totalCount = null
        state.currentPage = null
      })
      .addCase(getAllRolesLists.fulfilled, (state, action) => {
        state.loading = false
        const { success, data, stat } = action.payload || {}
        if (success) {
          const { total_records, current_page, total_pages } =
            action.payload || {}
          state.roles = data
          state.totalPages = total_pages
          state.totalCount = total_records
          state.currentPage = current_page
        }
      })
      .addCase(getAllRolesLists.rejected, (state, action) => {
        state.loading = false
      })

    builder
      .addCase(deleteRole.pending, state => {
        state.loading = true
      })
      .addCase(deleteRole.fulfilled, (state, action) => {
        state.loading = false
      })
      .addCase(deleteRole.rejected, (state, action) => {
        state.loading = false
      })

    builder
      .addCase(getPermissions.pending, state => {
        state.loading = true
      })
      .addCase(getPermissions.fulfilled, (state, action) => {
        const { success, data } = action.payload || {}
        if (success) {
          state.loading = false
          state.permissions = data
        }
      })
      .addCase(getPermissions.rejected, (state, action) => {
        state.loading = false
      })

    builder
      .addCase(createRole.pending, state => {
        state.loading = true
      })
      .addCase(createRole.fulfilled, (state, action) => {
        state.loading = false
      })
      .addCase(createRole.rejected, (state, action) => {
        state.loading = false
      })

    builder
      .addCase(getSingleRole.pending, state => {
        state.loading = true
        state.role = null
      })
      .addCase(getSingleRole.fulfilled, (state, action) => {
        state.loading = false
        const { success, data } = action.payload
        if (success) {
          state.role = data
        }
      })
      .addCase(getSingleRole.rejected, (state, action) => {
        state.loading = false
        state.role = null
      })
    builder
      .addCase(updateRole.pending, state => {
        state.loading = true
      })
      .addCase(updateRole.fulfilled, (state, action) => {
        state.loading = false
      })
      .addCase(updateRole.rejected, (state, action) => {
        state.loading = false
      })
    builder
      .addCase(getUserRoleAndPermissions.pending, state => {
        state.loading = true
      })
      .addCase(getUserRoleAndPermissions.fulfilled, (state, action) => {
        state.loading = false
        const { success, data } = action.payload || {}
        if (success) {
          state.loading = false
          state.userRole = data
        }
      })
      .addCase(getUserRoleAndPermissions.rejected, (state, action) => {
        state.loading = false
      })
    builder
      .addCase(getCandiateRoleData.pending, state => {
        state.loading = true
      })
      .addCase(getCandiateRoleData.fulfilled, (state, action) => {
        state.loading = false
        const { success, data } = action.payload || {}
        if (success) {
          state.loading = false
          state.candidateRole = data
        }
      })
      .addCase(getCandiateRoleData.rejected, (state, action) => {
        state.loading = false
      })
  },
})

export const { setPayload, resetPayload, toggleFilterVisibility } =
  rolesSlice.actions
export default rolesSlice.reducer
